// project import
import dashboard from './dashboard';
import utilities from './utilities';
import verifikasi from './verifikasi';
import support from './support';


// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [dashboard, utilities, verifikasi, support]
};

export default menuItems;
